{
  "title": "Socios",
  "subtitle": "Revendedores que venden OnBrand Mail a sus propios clientes.",
  "addPartner": "Añadir un socio",
  "loadError": "No se pudieron cargar los socios",
  "emptyTitle": "Aún no hay socios",
  "emptyDescription": "Un socio vende a sus propios clientes y conserva un margen. Añade uno y luego atribúyele sus clientes desde cada inquilino.",
  "colPartner": "Socio",
  "colMargin": "Margen",
  "colCustomers": "Clientes",
  "colStatus": "Estado",
  "colPayouts": "Pagos",
  "colCustomer": "Cliente",
  "colPaid": "Pagado",
  "colRate": "Tarifa",
  "colEarned": "Ganado",
  "statusPending": "Pendiente",
  "statusActive": "Activo",
  "statusSuspended": "Suspendido",
  "payoutsNotOnboarded": "Sin incorporar",
  "payoutsOnboarding": "Incorporación",
  "payoutsReady": "Listo",
  "payoutsRestricted": "Restringido",
  "payoutsBadge": "Pagos: {{status}}",
  "marginBadge": "{{margin}} de margen",
  "commissionOwed": "Adeudado",
  "commissionPaid": "Pagado",
  "commissionReversed": "Revertido",
  "commissionHeld": "Retenido",
  "updateError": "No se pudo actualizar ese socio.",
  "stripeOnboardingError": "No se pudo enviar la invitación de Stripe.",
  "partnerVerb": "{{name}} {{verb}}.",
  "partnerAdded": "{{name}} añadido.",
  "partnerAddedInvited": "{{name}} añadido e invitado a configurar los pagos de Stripe.",
  "partnerAddedNoEmail": "{{name}} añadido — no se pudo enviar la invitación. Abre el socio y vuelve a enviarla.",
  "verbReactivated": "reactivado",
  "verbSuspended": "suspendido",
  "activate": "Activar",
  "reactivate": "Reactivar",
  "suspend": "Suspender",
  "emailStripeInvite": "Enviar invitación de Stripe",
  "resendStripeInvite": "Reenviar invitación de Stripe",
  "stripeInviteSent": "Invitación de Stripe enviada a {{email}}.",
  "stripeInviteCopy": "No se pudo enviar el correo a {{email}}. Enlace copiado al portapapeles.",
  "stripeAlreadyOnboarded": "Este socio ya terminó la configuración de pagos de Stripe.",
  "startStripeOnboarding": "Enviar invitación de Stripe",
  "newOnboardingLink": "Reenviar invitación de Stripe",
  "marginPercent": "Margen (%)",
  "billingEmail": "Correo de facturación",
  "billingEmailDescription": "Donde llegan facturas, extractos de comisión y la invitación de Stripe.",
  "billingEmailPlaceholder": "accounts@northern-it.example",
  "commissions": "Comisión",
  "noCommissions": "Aún no se ha ganado nada. La comisión se registra cuando un cliente referido paga una factura, no cuando se emite.",
  "createTitle": "Añadir un socio",
  "createIntro": "Un socio vende a sus propios clientes y conserva un margen sobre el precio de lista. Atribúyele sus clientes desde cada inquilino después.",
  "createError": "No se pudo añadir ese socio",
  "createErrorShort": "No se pudo añadir ese socio.",
  "partnerFallback": "Socio",
  "nameLabel": "Nombre",
  "namePlaceholder": "Northern IT",
  "slugLabel": "Slug",
  "slugDescription": "Aparece en las rutas del portal y en los registros. Minúsculas, dígitos y guiones.",
  "slugPlaceholder": "northern-it",
  "marginLabel": "Margen",
  "marginDescription": "Parte del precio de lista que conserva este socio.",
  "stripePayouts": "Pagos de Stripe",
  "stripeActive": "Stripe aceptará transferencias a este socio. La comisión se envía cada hora.",
  "stripeNeedsInfo": "Stripe aún necesita información antes de pagar a este socio. La comisión sigue acumulándose entretanto y se envía en cuanto sea posible.",
  "stripeNeedsOnboarding": "Este socio no puede cobrar comisiones hasta completar la incorporación de Stripe. Solo hace falta para clientes referidos: a los socios mayoristas se les factura en su lugar.",
  "customersAttributed": "{{count}} cliente atribuido. Los clientes mayoristas se facturan a este socio al {{wholesale}} del precio de lista; los referidos nos pagan directamente y el margen se transfiere cuando nosotros cobramos.",
  "customersAttributed_other": "{{count}} clientes atribuidos. Los clientes mayoristas se facturan a este socio al {{wholesale}} del precio de lista; los referidos nos pagan directamente y el margen se transfiere cuando nosotros cobramos.",
  "suspendedAlert": "Suspendido: no se pueden atribuir clientes nuevos ni facturarles suscripciones nuevas. Las suscripciones ya en curso no se modifican.",
  "statementError": "No se pudo cargar el extracto",
  "multiCurrencyNote": "Estas entradas abarcan más de una moneda, así que los totales de arriba son recuentos de unidades menores, no un importe. Lee las líneas en su lugar.",
  "offboardedCustomer": "Cliente dado de baja",
  "noAccessTitle": "Sin acceso a socios",
  "noAccessBody": "Los acuerdos de revendedores los gestiona el personal de OnBrand Mail.",
  "viewAs": "Ver como socio",
  "viewAsStarted": "Viendo el portal como {{name}}.",
  "viewAsError": "No se pudo empezar a ver como ese socio.",
  "viewAsBannerTitle": "Viendo como {{name}}",
  "viewAsBannerBody": "Solo ves los clientes de este socio y lo que pueden alcanzar sus administradores. Las herramientas de administración de la plataforma permanecen ocultas hasta que salgas.",
  "exitViewAs": "Salir de la vista de socio",
  "viewAsExitError": "No se pudo salir de la vista de socio.",
  "resendPortalInvite": "Reenviar invitación al portal",
  "portalAccess": "Acceso al portal",
  "portalAccessHint": "Permite iniciar sesión y administrar los clientes de este socio. Separado de la configuración de pagos de Stripe.",
  "portalInviteTitle": "Invitar al portal",
  "portalInviteHint": "Envía un correo a {{name}} para que inicien sesión y configuren su cuenta de socio. Basta con iniciar sesión — no hay contraseña que crear.",
  "portalInviteEmail": "Correo de trabajo",
  "portalInviteEmailDesc": "La dirección con la que iniciarán sesión. Por defecto, el contacto de facturación.",
  "portalInviteDifferentOrgDesc": "Los socios casi siempre inician sesión desde su propio directorio. Desmarca solo si comparten el tuyo.",
  "portalInviteSent": "Invitación al portal enviada a {{email}}.",
  "portalInviteResent": "Invitación al portal reenviada a {{email}}.",
  "portalInviteNoEmailTitle": "{{email}} invitado — no se pudo enviar el correo",
  "portalInviteNoEmailBody": "La invitación está pendiente. Pídeles que inicien sesión con esa dirección; el rol se aplica al llegar.",
  "portalInviteErrorTitle": "No invitado",
  "portalInviteError": "No se pudo enviar esa invitación al portal."
}
